import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=1b11b073&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=1b11b073&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11b073",
  null
  
)

export default component.exports